export class EmptyCartError extends Error {
  constructor(cartRes) {
    super('Cart is empty', {
      cause: {
        cartRes
      }
    });
  }
}
export class CompletedCartError extends Error {
  constructor(cartRes) {
    super('Cart is completed', {
      cause: {
        cartRes
      }
    });
  }
}
//# sourceMappingURL=errors.js.map